import config from 'common/config';
import apiClient from '../../../common/api/apiClient';

/**
 * 获取用户设置信息
 * @returns {Promise} 包含用户设置的响应对象
 */
const loadSettings = () => {
  return apiClient.post(`${config.api.LOGIN_URL}/userManage/getSettings`);
};

/**
 * 获取当前登录用户信息
 * @returns {Promise} 包含用户信息的响应对象
 */
const getUser = () => {
  const url = `${config.api.LOGIN_URL}/userManage/getUser`;
  return apiClient.post(url);
};

const client = {
  loadSettings,
  getUser,
};

export default client;
